webpackJsonp([0],{

/***/ "/QJc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2LYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Shotgun")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light green",on:{"click":function($event){_vm.pullTrigger()}}},[_vm._v("Pull Trigger")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light blue-grey",on:{"click":function($event){_vm.destroyEvidence()}}},[_vm._v("Destroy Evidence")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AmHV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_MyScriptHelper__ = __webpack_require__("KmYP");
/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$myScriptHelper = __WEBPACK_IMPORTED_MODULE_0__helpers_MyScriptHelper__["a" /* default */];
  }
});

/***/ }),

/***/ "Bcmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rifle',
  data: function data() {
    return {
      destroyEvidenceAcitonText: 'Rifle Evidence Destroyed!',
      triggerActionText: 'Long Rifle Fired, Whopdie Doo!',
      splashPath: 'static/images/rifle.jpeg'
    };
  },

  methods: {
    destroyEvidence: function destroyEvidence() {
      this.doAnotherCoolThing(this.destroyEvidenceAcitonText, 'Rifle');
    },
    pullTrigger: function pullTrigger() {
      this.$myScriptHelper.doSomethingCool(this.triggerActionText, 'blue', 'Rifle', this.splashPath);
    }
  }
});

/***/ }),

/***/ "CyfP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shotgun',
  data: function data() {
    return {
      destroyEvidenceAcitonText: 'Shotgun Evidence Destroyed!',
      triggerActionText: '12 Gauge Shotshell Fired, BAM!',
      splashPath: 'static/images/shotgun.jpeg'
    };
  },

  methods: {
    destroyEvidence: function destroyEvidence() {
      this.doAnotherCoolThing(this.destroyEvidenceAcitonText, 'Shotgun');
    },
    pullTrigger: function pullTrigger() {
      this.$myScriptHelper.doSomethingCool(this.triggerActionText, 'green', 'Shotgun', this.splashPath);
    }
  }
});

/***/ }),

/***/ "DXNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Pistol")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light red",on:{"click":function($event){_vm.pullTrigger()}}},[_vm._v("Pull Trigger")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light blue-grey",on:{"click":function($event){_vm.destroyEvidence()}}},[_vm._v("Destroy Evidence")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pistol_Pistol__ = __webpack_require__("hDD4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Rifle_Rifle__ = __webpack_require__("bhpK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Shotgun_Shotgun__ = __webpack_require__("Mb7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_event_bus__ = __webpack_require__("h60m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  components: {
    Pistol: __WEBPACK_IMPORTED_MODULE_0__components_Pistol_Pistol__["a" /* default */],
    Rifle: __WEBPACK_IMPORTED_MODULE_1__components_Rifle_Rifle__["a" /* default */],
    Shotgun: __WEBPACK_IMPORTED_MODULE_2__components_Shotgun_Shotgun__["a" /* default */]
  },
  data: function data() {
    return {
      actionText: 'Pull any one of the triggers to shoot...',
      evidenceText: 'You have not yet fired any shots...',
      evidence: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__helpers_event_bus__["a" /* default */].bus.$on('populateEvidence', function (text, component) {
      _this.evidenceText = 'Nothing to see here :)';
      _this.evidence.push({
        gunType: component,
        text: text
      });
    });

    __WEBPACK_IMPORTED_MODULE_3__helpers_event_bus__["a" /* default */].bus.$on('destroyEvidence', function (component) {
      // eslint-disable-next-line
      var tempArr = _this.evidence.filter(function (a) {
        return a.gunType !== component;
      });
      _this.evidence = tempArr;
    });
  }
});

/***/ }),

/***/ "KmYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__("h60m");
/* eslint-disable */


function doSomethingCool(text, context, component, splashPath) {
  __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].bus.$emit('notify', text, context);
  __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].bus.$emit('populateEvidence', text, component);
  __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].bus.$emit('updateSplash', splashPath);
}

function doAnotherCoolThing(text, component) {
  __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].bus.$emit('notify', text, 'blue-grey');
  __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* default */].bus.$emit('destroyEvidence', component);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  doSomethingCool: doSomethingCool,
  doAnotherCoolThing: doAnotherCoolThing
});

/***/ }),

/***/ "Koot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fdafba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Uq01");
function injectStyle (ssrContext) {
  __webpack_require__("yqZr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fdafba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mb7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shotgun_vue__ = __webpack_require__("CyfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad5b6b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Shotgun_vue__ = __webpack_require__("2LYo");
function injectStyle (ssrContext) {
  __webpack_require__("ZXb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cad5b6b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shotgun_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad5b6b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Shotgun_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__("0lrd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_css__ = __webpack_require__("X0eL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_materialize_css_dist_css_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_index__ = __webpack_require__("AmHV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MyScriptHelper__ = __webpack_require__("KmYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Register global plugin
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugins_index__["a" /* default */]);

// Register global mixin
var mixin = {
  methods: {
    doAnotherCoolThing: __WEBPACK_IMPORTED_MODULE_4__helpers_MyScriptHelper__["a" /* default */].doAnotherCoolThing
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(mixin);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "Uq01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("VueJS Global Mixins and Plugins Example")]),_vm._v(" "),_c('p',[_vm._v("Tutorial at "),_c('a',{attrs:{"href":_vm.tutorialLink,"target":"_blank"}},[_vm._v("blog.mjshika.xyz")])]),_vm._v(" "),_c('img',{key:_vm.splashImage,staticClass:"splash-image",attrs:{"src":_vm.splashImage}}),_vm._v(" "),_c('home')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X0eL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZXb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bhpK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rifle_vue__ = __webpack_require__("Bcmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b0c16b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Rifle_vue__ = __webpack_require__("ss/F");
function injectStyle (ssrContext) {
  __webpack_require__("/QJc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57b0c16b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rifle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b0c16b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Rifle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h60m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  bus: bus
});

/***/ }),

/***/ "hDD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pistol_vue__ = __webpack_require__("zpyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f85279_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Pistol_vue__ = __webpack_require__("DXNZ");
function injectStyle (ssrContext) {
  __webpack_require__("Koot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37f85279"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pistol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f85279_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Pistol_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i3hq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('h5',[_vm._v(_vm._s(_vm.actionText))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m4"},[_c('pistol')],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('rifle')],1),_vm._v(" "),_c('div',{staticClass:"col s12 m4"},[_c('shotgun')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[(_vm.evidence.length === 0)?_c('h6',[_vm._v(_vm._s(_vm.evidenceText))]):_vm._l((_vm.evidence),function(item,key){return _c('div',{key:key,staticClass:"chip"},[_vm._v(_vm._s(item.text))])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d9b985_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("i3hq");
function injectStyle (ssrContext) {
  __webpack_require__("vgNo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53d9b985"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d9b985_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ss/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Rifle")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light blue",on:{"click":function($event){_vm.pullTrigger()}}},[_vm._v("Pull Trigger")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col s12"},[_c('button',{staticClass:"btn waves-effect waves-light blue-grey",on:{"click":function($event){_vm.destroyEvidence()}}},[_vm._v("Destroy Evidence")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vgNo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_event_bus__ = __webpack_require__("h60m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Home__ = __webpack_require__("lO7g");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_1__components_Home__["a" /* default */]
  },
  data: function data() {
    return {
      defaultSplashImage: 'static/images/splash.jpeg',
      splashImage: 'static/images/splash.jpeg',
      tutorialLink: 'https://blog.mjshika.xyz/blog/post/registering-globally-available-helper-scripts-in-vuejs'
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__helpers_event_bus__["a" /* default */].bus.$on('notify', function (text, context) {
      // eslint-disable-next-line
      Materialize.toast(text, 4000, context);
    });

    __WEBPACK_IMPORTED_MODULE_0__helpers_event_bus__["a" /* default */].bus.$on('updateSplash', function (splashPath) {
      _this.splashImage = splashPath || _this.defaultSplashImage;
    });

    __WEBPACK_IMPORTED_MODULE_0__helpers_event_bus__["a" /* default */].bus.$on('destroyEvidence', function () {
      _this.splashImage = _this.defaultSplashImage;
    });
  }
});

/***/ }),

/***/ "yqZr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zpyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pistol',
  data: function data() {
    return {
      destroyEvidenceAcitonText: 'Pistol Evidence Destroyed!',
      triggerActionText: 'Arabellum Fired, Yay!',
      splashPath: 'static/images/pistol.jpeg'
    };
  },

  methods: {
    destroyEvidence: function destroyEvidence() {
      this.doAnotherCoolThing(this.destroyEvidenceAcitonText, 'Pistol');
    },
    pullTrigger: function pullTrigger() {
      this.$myScriptHelper.doSomethingCool(this.triggerActionText, 'red', 'Pistol', this.splashPath);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.83c14aa013bd8fe943a7.js